import {Pipe, PipeTransform} from '@angular/core';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import {DEFAULT_DATE_FORMAT, INVALID_DATE_FORMAT} from 'shared/magic';
import {TranslocoService} from '@ngneat/transloco';
dayjs.extend(duration);

@Pipe({name: 'dateFormat'})
export class DateFormatPipe implements PipeTransform {

	constructor(private translocoService: TranslocoService) {}

	transform(date: string, format: string = DEFAULT_DATE_FORMAT, humanize = false): unknown {
		if (!date) return;
		if (date === INVALID_DATE_FORMAT) return this.translocoService.translate('journal.generic.invalidFormat');
		if (humanize) {
			const today = +dayjs();
			const dateVal = dayjs(date);
			const days = Math.floor(dateVal.diff(today) / (60 * 60 * 24 * 1000)) + 1;
			return dayjs.duration(days, 'days').humanize(true);
		}
		return dayjs(date).format(format);
	}
}
